import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SimpleTongueDto} from "../../../model/dto";

@Component({
  selector: 'app-tongue-select-dialog',
  templateUrl: './tongue-select-dialog.component.html',
  styleUrl: './tongue-select-dialog.component.scss'
})
export class TongueSelectDialogComponent {
  @Input() tongues: {type: string, tongues: SimpleTongueDto[]}[] = [];
  @Output() select: EventEmitter<SimpleTongueDto> = new EventEmitter();
  isShow = false;

  setShow(isShow): void {
    this.isShow = isShow;
  }

  onSelect(tongue: SimpleTongueDto) {
    this.select.emit(tongue);
  }
}
